/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionResponse } from './ConditionResponse';
import {
    ConditionResponseFromJSON,
    ConditionResponseFromJSONTyped,
    ConditionResponseToJSON,
    ConditionResponseToJSONTyped,
} from './ConditionResponse';
import type { ImageAnalysisDataResponse } from './ImageAnalysisDataResponse';
import {
    ImageAnalysisDataResponseFromJSON,
    ImageAnalysisDataResponseFromJSONTyped,
    ImageAnalysisDataResponseToJSON,
    ImageAnalysisDataResponseToJSONTyped,
} from './ImageAnalysisDataResponse';

/**
 * 
 * @export
 * @interface ValidateQuestPhotoSuccessResponse
 */
export interface ValidateQuestPhotoSuccessResponse {
    /**
     * Whether the photo validation was successful
     * @type {boolean}
     * @memberof ValidateQuestPhotoSuccessResponse
     */
    success: boolean;
    /**
     * ID of the created asset
     * @type {string}
     * @memberof ValidateQuestPhotoSuccessResponse
     */
    assetId?: string;
    /**
     * Only present on the CV fallback path; the matched CV conditions.
     * @type {Array<ConditionResponse>}
     * @memberof ValidateQuestPhotoSuccessResponse
     */
    matchingCriteria?: Array<ConditionResponse>;
    /**
     * 
     * @type {ImageAnalysisDataResponse}
     * @memberof ValidateQuestPhotoSuccessResponse
     */
    imageAnalysis?: ImageAnalysisDataResponse;
    /**
     * 
     * @type {string}
     * @memberof ValidateQuestPhotoSuccessResponse
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the ValidateQuestPhotoSuccessResponse interface.
 */
export function instanceOfValidateQuestPhotoSuccessResponse(value: object): value is ValidateQuestPhotoSuccessResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function ValidateQuestPhotoSuccessResponseFromJSON(json: any): ValidateQuestPhotoSuccessResponse {
    return ValidateQuestPhotoSuccessResponseFromJSONTyped(json, false);
}

export function ValidateQuestPhotoSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateQuestPhotoSuccessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'matchingCriteria': json['matchingCriteria'] == null ? undefined : ((json['matchingCriteria'] as Array<any>).map(ConditionResponseFromJSON)),
        'imageAnalysis': json['imageAnalysis'] == null ? undefined : ImageAnalysisDataResponseFromJSON(json['imageAnalysis']),
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function ValidateQuestPhotoSuccessResponseToJSON(json: any): ValidateQuestPhotoSuccessResponse {
    return ValidateQuestPhotoSuccessResponseToJSONTyped(json, false);
}

export function ValidateQuestPhotoSuccessResponseToJSONTyped(value?: ValidateQuestPhotoSuccessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'assetId': value['assetId'],
        'matchingCriteria': value['matchingCriteria'] == null ? undefined : ((value['matchingCriteria'] as Array<any>).map(ConditionResponseToJSON)),
        'imageAnalysis': ImageAnalysisDataResponseToJSON(value['imageAnalysis']),
        'imageUrl': value['imageUrl'],
    };
}

